module.exports = __webpack_public_path__ + "static/media/p0302.20975571.png";